import ReportLayout from 'src/pages/Reports/Common/report/ReportLayout';
import ReportDetails from 'src/pages/Reports/Common/report/ReportDetails';

const Solicitor = () => (
  <ReportLayout title="Clerk Solicitor Report">
    <ReportDetails
      title="Report Details"
      downloadEndpoint="solicitor_permit_application/download"
    />
  </ReportLayout>
);

export default Solicitor;
